import React from 'react';
interface FooterProps {
  onNavigate: (page: string) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  const handleNavClick = (e: React.MouseEvent, page: string) => {
    e.preventDefault();
    onNavigate(page);
  };
  return <footer className="bg-charcoal text-white pt-20 pb-8 border-t-4 border-victory-red" data-id="element-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10 mb-16" data-id="element-32">
          {/* Brand Col */}
          <div className="space-y-6 col-span-2 lg:col-span-1" data-id="element-33">
            <div className="cursor-pointer group inline-block" onClick={e => handleNavClick(e, 'home')} data-id="element-34">
              <img src="https://cdn.magicpatterns.com/uploads/64it8njJxRLMTBC7zyqg6G/VICTORY-LOGO-TRANSPARENT.png" alt="Victory Kitchen Z" className="h-24 w-auto transition-transform duration-300 group-hover:scale-105" data-id="element-35" />
            </div>
            <p className="font-body text-white/70 leading-relaxed max-w-md" data-id="element-36">
              African food with a soul. We combine family knowledge with
              culinary training to create classic West African cuisine in a
              modern way.
            </p>
          </div>

          {/* Menu Col */}
          <div data-id="element-37">
            <h4 className="font-heading text-xl uppercase tracking-wide mb-6 text-amber" data-id="element-38">
              Our Menu
            </h4>
            <ul className="space-y-4 font-body text-white/80" data-id="element-39">
              <li data-id="element-40">
                <a href="#" onClick={e => handleNavClick(e, 'main-dishes')} className="hover:text-amber transition-colors" data-id="element-41">
                  Main Dishes
                </a>
              </li>
              <li data-id="element-42">
                <a href="#" onClick={e => handleNavClick(e, 'drinks')} className="hover:text-amber transition-colors" data-id="element-43">
                  Drinks & Beverages
                </a>
              </li>
              <li data-id="element-44">
                <a href="#" onClick={e => handleNavClick(e, 'snacks')} className="hover:text-amber transition-colors" data-id="element-45">
                  Snacks & Extras
                </a>
              </li>
              <li data-id="element-46">
                <a href="#" onClick={e => handleNavClick(e, 'menu')} className="hover:text-amber transition-colors text-amber" data-id="element-47">
                  View Full Menu
                </a>
              </li>
            </ul>
          </div>

          {/* Services Col */}
          <div data-id="element-48">
            <h4 className="font-heading text-xl uppercase tracking-wide mb-6 text-amber" data-id="element-49">
              Services
            </h4>
            <ul className="space-y-4 font-body text-white/80" data-id="element-50">
              <li data-id="element-51">
                <a href="#" onClick={e => handleNavClick(e, 'catering')} className="hover:text-amber transition-colors" data-id="element-52">
                  Catering Services
                </a>
              </li>
              <li data-id="element-53">
                <a href="#" onClick={e => handleNavClick(e, 'catering')} className="hover:text-amber transition-colors" data-id="element-54">
                  Private Events
                </a>
              </li>
              <li data-id="element-55">
                <a href="#" onClick={e => handleNavClick(e, 'menu')} className="hover:text-amber transition-colors" data-id="element-56">
                  Online Ordering
                </a>
              </li>
              <li data-id="element-57">
                <a href="#" onClick={e => handleNavClick(e, 'menu')} className="hover:text-amber transition-colors" data-id="element-58">
                  BYOB & Takeout
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Col */}
          <div className="col-span-2 sm:col-span-1" data-id="element-59">
            <h4 className="font-heading text-xl uppercase tracking-wide mb-6 text-amber" data-id="element-60">
              Visit Us
            </h4>
            <ul className="space-y-4 font-body text-white/80" data-id="element-61">
              <li className="flex items-start" data-id="element-62">
                <span className="mr-2" data-id="element-63">📍</span>
                <span data-id="element-64">
                  7323 Landover Rd
                  <br data-id="element-65" />
                  Hyattsville, MD 20785
                </span>
              </li>
              <li className="flex items-center" data-id="element-66">
                <span className="mr-2" data-id="element-67">📞</span>
                <span data-id="element-68">(301) 386-6105</span>
              </li>
              <li className="flex items-center" data-id="element-69">
                <span className="mr-2" data-id="element-70">✉️</span>
                <span data-id="element-71">info@victorykitchenz.com</span>
              </li>
              <li className="flex items-start text-sm text-amber mt-4" data-id="element-72">
                <span className="mr-2" data-id="element-73">🕒</span>
                <span data-id="element-74">
                  Delivery: 12 noon – 8pm
                  <br data-id="element-75" />
                  (DMV metro area)
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-76">
          <p className="font-body text-sm text-white/50" data-id="element-77">
            &copy; {new Date().getFullYear()} Victory Kitchen Z. All rights
            reserved.
          </p>
          <div className="flex space-x-6 font-body text-sm text-white/50" data-id="element-78">
            <a href="#" className="hover:text-white transition-colors" data-id="element-79">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-80">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}